import React from 'react';
import PropTypes from 'prop-types';
import MediaPlayer from 'components/ui/MediaPlayer';

const Recording = props => {
  const { ziggeoApiKey, recording, hasZiggeoForAllMedia } = props;

  return (
    <div className="Card bg-white p-32 mt-24">
      <MediaPlayer
        hasZiggeoForAllMedia={hasZiggeoForAllMedia}
        recording={recording}
        ziggeoApiKey={ziggeoApiKey}
        customClass="Video Video--playable"
      />
    </div>
  );
};

Recording.propTypes = {
  ziggeoApiKey: PropTypes.string,
  recording: PropTypes.shape({}),
  hasZiggeoForAllMedia: PropTypes.bool,
};

export default Recording;
